import type { ReactElement } from 'react';
import { StyleguideApp } from '@xdocs/ui';
import { NotFoundPage } from './NotFoundPage.js';

/**
 * `/styleguide` (F75, task spec: "mount StyleguideApp from @xdocs/ui").
 * `StyleguideApp` is fully self-contained (its own Locale/Theme/Toast
 * providers) — mounting it here does not need this app's shell providers.
 *
 * Gating (F75 §8.5: "Dev/staff-gated (`DEV_MODE` or `role IN
 * ('moderator','admin')`), not indexed"): `import.meta.env.DEV` covers the
 * dev-mode half. The staff-role half needs a user-profile read this app
 * can't do yet — no WS op returns the authenticated user's `role` (only
 * `auth.handshake` → `{userId, sessionId}`, no `user.get`/`me` op exists in
 * the frozen `wsOp` enum yet). Flagged as an open issue for whichever
 * workstream adds that op; production builds fail closed to `NotFoundPage`
 * (not indexed) until then rather than exposing the gallery to everyone.
 */
export function StyleguideRoute(): ReactElement {
  if (!import.meta.env.DEV) {
    return <NotFoundPage />;
  }
  return <StyleguideApp />;
}
